/* MUI */
import { Box, Button, Flex } from '@auviknetworks/iceberg-ui';
import { CircularProgress } from '@mui/material';

/* React */
import React from 'react';

/* NPM */
import { useFormContext } from 'react-hook-form';

/**
 * To use the component, it must be wrapped in a <Form> component
 * which provides the react-hook-form context provider for useFormContext.
 */
export const SaveAndContinue = ({
    buttonText,
    disabled,
    alignItems = 'center',
    justifyContent = 'center'
}) => {
    const { formState } = useFormContext();
    const { isSubmitting } = formState;

    return (
        <Flex
            width="100%"
            flexDirection="column"
            justifyContent={justifyContent}
            alignItems={alignItems}
        >
            <Box display="flex">
                {isSubmitting && (
                    <Box marginRight={1}>
                        <CircularProgress size="32px" />
                    </Box>
                )}
                <Button
                    data-trackid="client_forms_saveAndContinue"
                    type="submit"
                    disabled={isSubmitting || disabled}
                >
                    {buttonText}
                </Button>
            </Box>
        </Flex>
    );
};
